Auth = require 'db/auth'
Dialog = undefined
queueRequire -> Dialog = require 'views/lib/dialog'
getExperiment = require 'lib/experiments/simple-test'
Member = undefined
queueRequire -> Member = require 'models/member'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Organization = undefined
queueRequire -> Organization = require 'models/organization'
$ = require 'jquery'
log = require 'debug/log'
_ = require 'underscore'
f = require 'effing'
Promise = require 'bluebird'
ninvoke = require 'lib/util/ninvoke'
ApiError = require 'network/api-error'
xtend = require 'xtend'
{ ErrorViews } = require 'common/data/error-views'

loadOrganizationAccountView = ->
  `import(/* webpackChunkName: "organization-account-view" */'views/organization/organization-account-view')`
loadOrganizationBillingView = ->
  `import(/* webpackChunkName: "organization-billing-view" */'views/organization/organization-billing-view')`
loadOrganizationBoardsView = ->
  `import(/* webpackChunkName: "organization-boards-view" */'views/organization/organization-boards-view')`
loadOrganizationExportView = ->
  `import(/* webpackChunkName: "organization-export-view" */'views/organization/organization-export-view')`
loadOrganizationMembersView = ->
  `import(/* webpackChunkName: "organization-members-view" */'views/organization/organization-members-view')`

module.exports =
  routes: [
    ['org/:id', 'organizationById']
    [':name/members/guests', 'organizationGuestsView']
    [':name/members', 'organizationMembersView']
    [':name/:username/cards', 'organizationMemberCardsView']
    [':name/export', 'organizationExportView']
  ]

  organizationBoardsView: (orgname) ->
    loadOrganizationBoardsView().then (OrganizationBoardsView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationBoardsData'
        additionalFns:
          members: 'loadOrganizationMemberGhost'
        viewClass: OrganizationBoardsView
        getLocation: @getOrganizationUrl
      .done()

  organizationMembersView: (orgname) ->
    loadOrganizationMembersView().then (OrganizationMembersView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationMembersData'
        viewClass: OrganizationMembersView
        additionalFns:
          organization: 'loadOrganizationMembersExtraData'
        getLocation: @getOrganizationMembersUrl
        viewOptions: @getMemberPageViewOptions(orgname, 'team-member')
      .done()

  organizationGuestsView: (orgname) ->
    loadOrganizationMembersView().then (OrganizationMembersView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationMembersData'
        viewClass: OrganizationMembersView
        additionalFns:
          organization: 'loadOrganizationMembersExtraData'
        getLocation: @getOrganizationGuestUrl
        viewOptions: @getMemberPageViewOptions(orgname, 'guest')
      .done()

  getMemberPageViewOptions: (orgname, memberFilterType) ->
    initialMemberTypeFilter: memberFilterType,
    routeToMemberType:
      (memberType) =>
        if memberType == 'team-member'
          @navigate(@getOrganizationMembersUrl(orgname), { trigger: false })
        else if memberType == 'guest'
          @navigate(@getOrganizationGuestUrl(orgname), { trigger: false })

  organizationMemberCardsView: (orgname, username) ->
    # This now lives on the member cards page
    @navigate(@getOrganizationMemberCardsUrl(orgname, username), { trigger: true })

  organizationAccountView: (orgname) ->
    loadOrganizationAccountView().then (OrganizationAccountView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationData'
        viewClass: OrganizationAccountView
        getLocation: @getOrganizationAccountUrl
        membersOnly: true
      .done()

  organizationExportView: (orgname) ->
    loadOrganizationExportView().then (OrganizationExportView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationExportData'
        viewClass: OrganizationExportView
        getLocation: @getOrganizationExportUrl
        adminOnly: true
      .done()

  organizationBillingView: (orgname, options = {}) ->
    loadOrganizationBillingView().then (OrganizationBillingView) =>
      @displayOrganizationPage
        orgname: orgname
        loadFn: 'loadOrganizationData'
        viewClass: OrganizationBillingView
        getLocation: @getOrganizationBillingUrl
        urlOptions: { returnUrl: options.returnUrl }
      .done()

  displayOrganizationPage: (settings) ->
    { orgname, username, product, urlOptions, viewOptions } = settings

    log('controller', ['organization'])

    Promise.using @getSpinner(), =>
      ModelLoader.release 'top-level'
      ModelLoader.for 'top-level', settings.loadFn, orgname
      .tap (org) ->
        Promise.all _.values(settings.additionalFns ? {}).map (methodName) ->
          ModelLoader[methodName] org.id, username
      .then (organization) =>
        member = ModelCache.findOne(Member, 'username', username)

        if Auth.me() && Auth.isLoggedIn() && !Auth.confirmed() &&
            getExperiment('confirmDuringSignup').get('enabled')
          return @navigate '/confirm-email', { trigger: true }

        if (!organization.owned() && settings.adminOnly) ||
            (!organization.isMember(Auth.me()) && settings.membersOnly) ||
            (settings.businessClass? && !organization.isFeatureEnabled(settings.businessClass))
          @organizationBoardsView(orgname)
          return organization

        @clearPreviousView()

        @setViewType(organization)

        options = _.extend({ urlOptions }, viewOptions)

        if member
          options.member = member

        if product?
          options.product = product

        options.modelCache = @getCurrentModelCache()

        organizationView = @topLevelView(settings.viewClass, organization, options)
        @showHeader()

        $('#classic-body').addClass('body-tabbed-page')
        $('#content')
          .empty()
          .append('<div class="js-boards-page-banners"></div><div class="js-boards-page"></div>')
          .append(organizationView.render().el)
        @focusContent()

        title = "#{organization.get('displayName')} (#{organization.get('name')})"

        loc = settings.getLocation.apply @, if member
          [organization.get('name'), member.get('username'), urlOptions]
        else if product
          [organization.get('name'), product, urlOptions]
        else
          [organization.get('name'), urlOptions]

        @setLocation
          title: title,
          location: loc

        return organization
      .catch ApiError.Unconfirmed, =>
        ninvoke ModelCache, 'waitFor', 'Member', Auth.myId()
        .then =>
          @displayErrorPage _.extend
            errorType: ErrorViews.UNCONFIRMED_ORG_NOT_FOUND
          , Auth.me().toJSON()
      .catch ApiError, =>
        @displayErrorPage()



// WEBPACK FOOTER //
// ./app/scripts/controller/organization-routes.coffee